import {
  Briefcase,
  Building,
  Cloud,
  Landmark,
  Megaphone,
  Store,
  type LucideIcon,
} from "lucide-react"

// CONCEPT — v3 of the "who it's for" vocabulary, replacing the four
// audiences from data/audiences.ts (Retailers & brands / Consultancies &
// SaaS / Commercial real estate / Restaurants & hospitality) with the six
// Anna gave directly: Retail analytics, Consultancies, SaaS, Commercial
// Real Estate, Marketing, Civic.
//
// v3: data/audiences.ts now has real sections for five of the six — SaaS
// and Marketing split/added with real jobs (see that file's v2 comment for
// where the copy came from).
//
// v4 — per Anna, Civic gets a real section: Area Identification and Area
// Development Reporting are both tagged Urban Development in the real Docs
// catalog, and two of the real worked examples (the 16th Street reopening
// in Denver, Grünerløkka's district tracking) are civic/public-investment
// cases already, just not yet reframed for that audience. Same jobs Anna
// already grounded for Consultancies/Marketing/CRE, reused for a civic
// framing — same mechanism, different audience.
//
// Ids match data/audiences.ts, so callers can look an audience up directly.
// Restaurants & hospitality is still not in this list on purpose (Anna's
// list, not an oversight) — it exists on the real /solutions page, just
// not promoted in this nav.

export type AudienceNavItem = {
  id: string
  icon: LucideIcon
  name: string
  teaser: string
  href: string
}

export const AUDIENCES_NAV: AudienceNavItem[] = [
  {
    id: "retail",
    icon: Store,
    name: "Retailers",
    teaser: "Where a brand stands against competitors, and who actually visits.",
    href: "/solutions/retail",
  },
  {
    id: "marketing",
    icon: Megaphone,
    name: "Marketers",
    teaser: "Target and measure campaigns by where people actually go.",
    href: "/solutions/marketing",
  },
  {
    id: "saas",
    icon: Cloud,
    name: "SaaS",
    teaser: "Location context, wired into the product.",
    href: "/solutions/saas",
  },
  {
    id: "consultancies",
    icon: Briefcase,
    name: "Consultancies",
    teaser: "Answers for any client question, from one location to a whole market.",
    href: "/solutions/consultancies",
  },
  {
    id: "commercial-real-estate",
    icon: Building,
    name: "Commercial Real Estate",
    teaser: "The foot traffic and trade area behind the asset, tracked over time.",
    href: "/solutions/commercial-real-estate",
  },
  {
    id: "civic",
    icon: Landmark,
    name: "Public services",
    teaser: "Public investment, measured against what it actually delivered.",
    href: "/solutions/civic",
  },
]
